import React from "react";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { Icon, Card } from "selfly-ui-react";

import "./DeviceSortingSelector.scss";

export default class DeviceSortingSelector extends React.Component {
    reorderHelper = (items, startIndex, endIndex) => {
        // console.log("\nREORDER ORIG", items.reduce((acc, cur) => {acc.push(cur.description); return acc}, []));
        const result = Array.from(items);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
        // console.log("REORDER AFTER", result.reduce((acc, cur) => {acc.push(cur.description); return acc}, []));
        return result;
    };

    handleDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const items = this.reorderHelper(this.props.sortingRules, result.source.index, result.destination.index);

        this.props.onChange(items);
    };

    onClickHandler = item => {
        // console.log("On click", item);
        this.props.onChange(
            this.props.sortingRules.map(rule => {
                if (rule.id !== item.id) {
                    return rule;
                }
                rule.reverse = !rule.reverse;
                return rule;
            })
        );
    };

    itemStyle = (isDragging, draggableStyle, nth) => ({
        userSelect: "none",
        padding: "0.5rem 1rem",
        margin: "0.5rem",
        borderRadius: "0.25rem",
        color: "white",
        textShadow: "0 0 5px black",
        background: isDragging ? "lightgreen" : ["#529014", "#67B419", "#8DC753", "#B3D98C", "#D9ECC5"][nth],
        ...draggableStyle,
    });

    render() {
        const arrayToBeSorted = this.props.sortingRules ? this.props.sortingRules : [];
        // console.log("Array To Be Sorted: ", arrayToBeSorted.reduce((acc, cur) => {acc.push(cur.description); return acc}, []));

        // const sortingDescriptions = arrayToBeSorted.reduce((acc, cur, ind, arr) => {
        //     let str = acc + cur.description;
        //     if (ind < arr.length - 1) {
        //         str = str + ", ";
        //     }
        //     return str;
        // }, "");

        return (
            <div className="device-sorting-selector">
                {/* <Accordion icon="sort" title={`Sorting (${sortingDescriptions})`}> */}
                <Card title="Sorting">
                    <p>
                        Drag & Drop the sorting rule boxes to change the priority of device sorting. Clicking the box
                        changes the direction.
                    </p>

                    <DragDropContext onDragEnd={this.handleDragEnd}>
                        <Droppable droppableId="sorterDroppable" direction="horizontal">
                            {(provided, snapshot) => (
                                <div className="sorting-container" ref={provided.innerRef} {...provided.droppableProps}>
                                    {arrayToBeSorted.map((item, ind) => (
                                        <Draggable key={item.id} draggableId={item.id} index={ind}>
                                            {(provided, snapshot) => (
                                                <div
                                                    onClick={() => this.onClickHandler(item)}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    style={this.itemStyle(
                                                        snapshot.isDragging,
                                                        provided.draggableProps.style,
                                                        ind
                                                    )}
                                                >
                                                    {item.description}{" "}
                                                    {item.reverse ? (
                                                        <Icon size="sm">keyboard_arrow_down</Icon>
                                                    ) : (
                                                        <Icon size="sm">keyboard_arrow_up</Icon>
                                                    )}
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    </Card>
                {/* </Accordion> */}
            </div>
        );
    }
}
